import axios from "axios";
import config from "../../helpers/config";
import instance from "../../helpers/AxiosInterceptor";


export const downloadTemp = async () => {
    return await axios.get(`${config.baseURL}/vehicule/template/download`,
        {
            headers: {
                "Authorization": "Bearer " + JSON.parse(localStorage.getItem("authUser")).accessToken
            }
        })
};

export const uploadData = async (formData) => {
    let headers = { "Content-type": "multipart/form-data", "Authorization": "Bearer " + JSON.parse(localStorage.getItem("authUser")).accessToken }
    return await axios.post(`${config.baseURL}/vehicule/upload`, formData, { headers: headers });
};

export const extractData = async (formData) => {
    let headers = { "Content-type": "multipart/form-data", "Authorization": "Bearer " + JSON.parse(localStorage.getItem("authUser")).accessToken }
    return await axios.post(`${config.baseURL}/vehicule/extract`, formData, { headers: headers });
};

export const search = (query) => {
    return instance.post(`/vehicule/search`, JSON.stringify(query));
};

export const find = (id) => {
    return instance.get(`/vehicule/find/${id}`);
};

export const loadStatistics = () => {
    return instance.get(`/vehicule/bilan`);
};

export const uploadDocument = async (formData) => {
    let headers = { "Content-type": "multipart/form-data", "Authorization": "Bearer " + JSON.parse(localStorage.getItem("authUser")).accessToken }
    return await axios.post(`${config.baseURL}/vehicule/upload`, formData, { headers: headers });
    
};

export const deleteDocument = (id) => {
    return instance.delete(`/vehicule/document/${id}`);
};

export const create = (request) => {
    return instance.post(`/vehicule/create`, JSON.stringify(request));
};

export const update = (request) => {
    return instance.put(`/vehicule/update`, JSON.stringify(request));
};

export const deleteRec = (id) => {
    return instance.delete(`/vehicule/delete/${id}`);
};
